import React from "react";
import {Box, Button, Column, Columns, Title} from "@allxsmith/bestax-bulma";
import useInput from "../../../hooks/useInput";
import usePostInspectionType from "../../../hooks/usePostInspectionType";

function InspectionType() {
  let [inspectionType, nameInput] = useInput({
    type: "text",
    label: "Inspection Name"
  });
  let [reminderDays, reminderInput] = useInput({
    type: "number",
    label: "Reminder (days in advance)"
  });
  let [warningDays, warningDaysInput] = useInput({
    type: "number",
    label: "Warning (days in advance)"
  });

  reminderDays = parseFloat(reminderDays);

  const [, postInspectionType] = usePostInspectionType({
    inspection_type: inspectionType,
    reminder_days: reminderDays,
    warning_days: warningDays
  });

  const handleSubmit = () => {
    postInspectionType();
  };

  return (
    <Box className="settings_type">
      <details>
        <summary><Title>Add Inspection Type</Title></summary>
      <Columns isMultiline>
        {nameInput}
        {reminderInput}
        {warningDaysInput}
      </Columns>
      <Columns isMultiline>
        <Column>
          <Button onClick={handleSubmit} color={"success"} isFullWidth>
            Add
          </Button>
        </Column>
      </Columns>
      </details>
    </Box>
  );
}

export default InspectionType;
